import { Dialog } from 'primereact/dialog';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeModalContent = (props: { data: string }) => {
  return <QRCodeSVG value={props.data} style={{ height: '100%', width: '100%' }} />;
};

const QRCodeModal = (props: QRCodeModalProps) => {
  return (
    <Dialog
      className={'modal-container'}
      modal
      draggable={false}
      dismissableMask
      visible={props.visible}
      onHide={props.onHide}
      position={'center'}
      style={{ width: '65vh', height: '65vh' }}
      contentStyle={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        margin: 0,
        padding: '1rem'
      }}
      showHeader={false}
      closable={false}>
      <QRCodeModalContent data={props.data} />
    </Dialog>
  );
};

export interface QRCodeModalProps {
  visible: boolean;
  onHide: () => void;
  data: string;
}

export default QRCodeModal;
